import { DocumentMediaModel } from '@phdsoft/common';

export enum DocumentsReduxActions {
  LIST_DOCUMENTS = 'LIST_DOCUMENTS'
}

export class DocumentsReduxReducer {

  public static listDocuments(state: DocumentMediaModel[] = [], action): DocumentMediaModel[] {
    let _RETURN_STATE = null;

    switch (action.type) {
      case DocumentsReduxActions.LIST_DOCUMENTS:
        _RETURN_STATE = action.payload;
        break;
      default:
        _RETURN_STATE = state;
        break;
    }

    // console.log('📡 getAssetDocuments', { action, state: _RETURN_STATE });

    return _RETURN_STATE;
  }
}
